const angular = require('angular')
const findIndex = require('lodash/findIndex')
const ionic = require('ionic')
const forEach = require('lodash/forEach')
const every = require('lodash/every')
const cloneDeep = require('lodash/cloneDeep')
const get = require('lodash/get')
const filter = require('lodash/filter')
const map = require('lodash/map')
const unionBy = require('lodash/unionBy')
const { hook: globalHook, utils: globalUtils } = require('js/global/module')

module.exports = ['$scope', '$rootScope', '$q', 'wechatService', '$state', '$translate', '$utils', 'mailService', 'mailFolderService',
  'readService', 'netFolderService', 'Message', '$ionicActionSheet', '$phoneModal', '$ionicPopover', '$sce', '$location',
  '$ionicHistory', '$cookies', '$ionicScrollDelegate', 'KeywordSearchMail', '$window', 'User', '$http', '$loading', '$ionicPopup', 'recallResultType',
  'secondAuthService', 'contactService', 'LocalStorage', '$timeout', '$ionicViewSwitcher', 'IndexedDB', '$$misc', 'globalMailService',
  function ($scope, $rootScope, $q, wechatService, $state, $translate, $utils, mailService, mailFolderService, readService,
    netFolderService, Message, $ionicActionSheet, $phoneModal, $ionicPopover, $sce, $location, $ionicHistory, $cookies,
    $ionicScrollDelegate, KeywordSearchMail, $window, User, $http, $loading, $ionicPopup, recallResultType,
    secondAuthService, contactService, LocalStorage, $timeout, $ionicViewSwitcher, IndexedDB, $$misc, globalMailService) {
    $scope.params = $state.params
    $scope.isMailDealings = $scope.params.isMailDealings === 'true' // 判断当前是否是来往邮件
    $scope.isSent = $scope.params.fid === '3' // 判断当前是否是已发送文件夹
    $scope.mboxa = $scope.params.mboxa || ''
    const mboxId = $scope.mboxa ? parseInt($scope.mboxa.split('@')[1]) : undefined
    const access = $scope.mboxa === '' ? -1 : (mboxId ? User.getAccountAccessById(mboxId) : User.getSelectedAccountAccess())
    $scope.currentAccountAccess = access
    $scope.reason4Reject = ''
    $scope.reloadMail = initReadMail

    console.log('$rootScope.settings.wechatMiniProgram: ', $rootScope.settings.wechatMiniProgram)
    if ($rootScope.settings.wechatMiniProgram) {
      // 不展示header
      $rootScope.settings.wechatMiniShowHeader = false
      // document.addEventListener('UniAppJSBridgeReady', function() {
      //   uni.getEnv(function(res) {
      //     console.log('当前环境：' + JSON.stringify(res))
      //   })
      // })
      const wechatData = JSON.parse($location.$$search.wechat)
      $scope.params.mid = wechatData.fid
    }

    // 设置标志位，初始化读信完成的情况下进入才不会重新加载
    $scope.isInitReadMailSuccess = false
    $scope.$on('$ionicView.enter', function(e) {
      if (!e.targetScope.isInitReadMailSuccess) {
        initReadMail()
      }
    })

    // 初始化读信
    //  messageItem 当前邮件在邮件列表中的Message实例
    //  readingMsgInfo 当前邮件信息
    function initReadMail() {
      const { fid, keyword, selectedTag, mid } = $scope.params

      // 获取文件夹实例
      const getFolder = function(fid, keyword, selectedTag) {
        if ($rootScope.isReadOnly) return $q.resolve(null) // 隐藏header无需获取文件夹和上下文

        return keyword
          ? $q.resolve(mailFolderService.getSearchFolder(selectedTag, keyword, false, $scope.isMailDealings)) // 搜索列表进入读信
          : mailFolderService.getFolder(fid) //  邮件列表进入读信
      }
      // 获取当前邮件在列表中的信息
      const getMailListInfo = function(mid) {
        if ($rootScope.isReadOnly) return $q.resolve(null) // 隐藏header无需获取文件夹和上下文

        const messages = $scope.folder.getMessages() || []

        // 从邮件列表进入的情况
        let getMessagesDefer = $q.resolve(messages)
        // 单点与直接刷新的情况
        if (!messages.length) {
          const currentFolderId = $scope.folder.id
          if ($scope.folder instanceof KeywordSearchMail || currentFolderId === -2) {
            getMessagesDefer = $q.resolve(null)
          } else {
            const isVirtualFolderIds = !!~[-1, -3, -5].indexOf(currentFolderId)
            const flagsOrMboxa = isVirtualFolderIds ? $scope.folder.filter.flags : $scope.mboxa
            const fidsOrfid = isVirtualFolderIds ? $scope.folder.fids : fid
            mid = !~mid.indexOf(':') ? '1:' + mid : mid // 兼容wmsvr特殊处理 LKFBK-3043
            getMessagesDefer = $scope.folder.getBeforeAfterMessages(fidsOrfid, -1, mid, flagsOrMboxa)
          }
        }

        return getMessagesDefer.then(function (data) {
          data = data || []
          const index = findIndex(data, item => $utils.$email.parseMid(item.id) === $utils.$email.parseMid(mid))
          if (index === -1) return null

          const messageItem = data[index]
          messageItem.preMid = data[index - 1] && data[index - 1].id
          messageItem.nextMid = data[index + 1] && data[index + 1].id
          return messageItem
        }, function (err) {
          // listMessages接口报错，返回空数组，不影响读信页流程
          console.log('getMailListInfo error', err)
          return null
        })
      }
      // 修复safari表格无法显示小于等于0.5px或0.5pt边框的问题，在ios平台下检测到td元素的borderWidth小于等于0.5就把该borderWidth置为0.6
      const fixSafariTableBorderWidthIssue = function() {
        if (ionic.Platform.isIOS()) {
          $timeout(_ => {
            const tdList = document.querySelectorAll('td')
            forEach(tdList, td => {
              const temp = td.style.borderWidth
              if (!temp) return

              const num = temp.match(/[^a-zA-Z]+/ig)
              const unit = temp.match(/[a-zA-Z]+/ig)
              if (parseInt(num[0]) <= 0.5 && ['pt', 'px'].indexOf(unit[0]) !== -1) {
                td.style.borderWidth = '0.6' + unit[0]
              }
            })
          })
        }
      }
      // 转换所有类型的变量为字符串(方便打印)
      const getPrintStr = function(tmp) {
        let type = Object.prototype.toString.call(tmp).match(/\[object (\w+?)\]/)
        type = type && type[1]
        if (~['Array', 'Object'].indexOf(type)) return JSON.stringify(tmp)
        if (~['Error'].indexOf(type)) return tmp.stack

        return tmp
      }

      // 利用angluarjs的then有做catch捕获来避免此处try catch
      $scope.readError = ''
      $scope.isLoading = true
      $q.resolve()
        .then(_ => getFolder(fid, keyword, selectedTag))
        .then(res => {
          console.log('getFolder', res)
          $scope.folder = res

          const options = {id: mid, mboxa: $scope.isMailDealings ? '' : $scope.mboxa, part: '', markRead: !$scope.isReadOnly}
          const returnAttSize = $rootScope.settings.featureControl.read.enableAttachmentDecodedSize
          // CM-40308 | XT606可以直接用 ['attsize', '@default']
          returnAttSize && (options.attrIds = [
            'attsize', 'from', 'to', 'cc', 'bcc', 'replyTo', 'flags', 'requestReadReceipt', 'subject', 'sentDate',
            'priority', 'antispamInfo', 'html', 'text', 'attachments', 'calendar'
          ])
          return $q.all([getMailListInfo(mid), readService.readMessage(options)])
        })
        .then(res => {
          console.log('messageItem', res[0])
          console.log('mailMessage', res[1])
          const messageItem = res[0]
          const mailMessage = res[1]
          const currentUser = User.getCurrentUser()

          mailMessage.id = mid
          mailMessage.isStranger = contactService.isStranger(mailMessage.from[0])
          mailMessage.auditerAllName = currentUser.config.true_name
            ? `"${currentUser.config.true_name}"<${currentUser.config.email}>` : currentUser.config.email
          $scope.readingMsgInfo = mailMessage
          $scope.isAudit = mailMessage.isAudit
          $scope.isWebReadOnly = mailMessage.flags.webReadOnly
          // 邮件在列表中没有构造Message对象的实例,则构造实例
          $scope.messageItem = messageItem || Message.buildMessages([mailMessage])[0]
          // 主账号和代理的共享账号才能更改未读
          const accessNum = User.getSelectedAccountAccess()
          const hasAccess = accessNum === -1 || accessNum === 1
          hasAccess && ($scope.messageItem.messageInfo.flags.read = true)
          angular.extend($scope.messageItem.messageInfo.flags, $scope.readingMsgInfo.flags)
          $scope.recallStatus = get($scope.messageItem, 'messageInfo.rclStatus') !== undefined
          $scope.showComplete = false // 是否显示收件人、抄送人等信息

          fixSafariTableBorderWidthIssue()
          // 修复微信读信无法显示图片问题 ECM-298
          const urlPrefix = currentUser.wmsvrClient.getWmsvrURLPrefix()
          return $utils.$misc.MD.isWeChat ? $http({
            method: 'GET',
            url: urlPrefix + '/generateSidCookie.jsp?sid=' + currentUser.sid,
          }).catch(_ => '') : $q.resolve(null)
        })
        .then(_ => {
          console.log('initReadMail success', $scope.readingMsgInfo)
          $scope.readingMsgInfo.mailContent = $utils.$html.filterMailContent($scope.readingMsgInfo.mailContent, $rootScope.settings.mailContentMaxLimit)
          $scope.$broadcast('READ.MAINCONTENT', $scope.readingMsgInfo.mailContent)
          $scope.$emit('READ.MESSAGE', $scope.readingMsgInfo)
          $scope.isInitReadMailSuccess = true
        })
        .finally(_ => {
          console.log('initReadMail finally')
          // 防止报错的时候loading太快消失
          $timeout(_ => ($scope.isLoading = false), 300)
          $scope.$broadcast('scroll.refreshComplete')
        })
        .catch(err => {
          console.log('initReadMail failed', err)
          try {
            err.message = angular.isObject(err)
              ? (err.stack || err.message || getPrintStr(err))
              : ({message: getPrintStr(err)})

            // 修复单点读信需要二次验证的问题
            if (err.code === 'FA_NEED_AUTH2') return secondAuthService.alertFolderUnlock(initReadMail)
          } catch (e) {
            err = e
            err.message = err.stack
          }

          if (err.code === 'FA_BAD_NETWORK') err.code = 'FAIL_LOAD'
          let mainErrMsg = $translate.instant(`READ.${err.code || 'FAIL'}`)
          mainErrMsg += `, <a href="javascript:void(0)" ng-click="reloadMail()">${$translate.instant('READ.RELOAD')}</a>
          <i class="icon iconfont icon-iconrefresh"></i>
          `
          $scope.readError = `<div class="message-tips error">${mainErrMsg}</div>`
          console.log('initReadMail readError', $scope.readError)
        })
    }

    $scope.formatAuditeeType = function (data) {
      let res = $translate.instant('OP.UNKNOWN')
      switch (data) {
        case '0':
          res = $translate.instant('OP.UNKNOWN')
          break
        case '1':
          res = $translate.instant('OP.AUDIT_SENDER')
          break
        case '2':
          res = $translate.instant('OP.AUDIT_RECIPIENT')
          break
        default:
          break
      }
      return res
    }

    // 底部options初始化
    function initFooterOptions() {
      // 生成每个option数据
      const generateData = function(isShow, isDisabled, iconClass, label, clickEvent) {
        clickEvent = clickEvent || (_ => {})
        return {
          isShow,
          isDisabled,
          iconClass,
          label: $translate.instant(label),
          clickEvent: clickEvent,
        }
      }

      const isAudit = $scope.isAudit // 是否需审核邮件（isAudit）
      const isSent = $scope.isSent // 是否已发送文件夹邮件（isSent）
      const recallStatus = $scope.recallStatus // 是否已召回（recallStatus）
      const accountAccess = $scope.currentAccountAccess // 共享文件夹权限（accountAccess）， -1(主账号) 0(只读) 1(代理) 2(代表)
      const readError = !!$scope.readError // 是否读信出错（readError）

      const optionsType1 = filter(map([
        [isAudit, false, 'icon-Audit_pass', 'OP.AUDIT_PASS', $scope.openAuditModal.bind(null, true)], // 审核通过
        [isAudit, false, 'icon-Audit_refusal', 'OP.AUDIT_REJECT', $scope.openAuditModal.bind(null, false)], // 审核拒绝
        [isSent && recallStatus && accountAccess, false, 'icon-icon_recall', 'OP.VIEW_RECALL_RESULT', $scope.openRecallConfirm], // 召回结果
        [
          isSent && !recallStatus && accountAccess, !$scope.messageItem.messageInfo.recallable,
          'icon-icon_recall', 'OP.RECALL_MAIL', $scope.openRecallConfirm
        ], // 召回邮件
        [isSent, !$scope.messageItem.messageInfo.recallable, 'icon-icon_state', 'OP.STATUS', $scope.openDeliveryStatusModal], // 投递状态
        [isSent, false, 'icon-iconwrite', 'OP.EDIT_AGAIN', $scope.sendAgain], // 再次编辑
        [accountAccess, false, 'icon-iconreply', 'OP.REPLY', $scope.reply], // 回复
        [accountAccess, false, 'icon-icon_replyall', 'OP.REPLY_ALL', $scope.replyAll], // 回复全部
        [accountAccess, false, 'icon-iconforward', 'OP.FORWARD', $scope.forward], // 转发
        [!!~[-1, 1].indexOf(accountAccess) && !$rootScope.settings.wechatMiniProgram, false, 'icon-iconmove', 'OP.MOVE', $scope.moveMessage], // 移动
        [!!~[-1, 1].indexOf(accountAccess), false, 'icon-iconemail', 'OP.MARK_AS_UNREAD', $scope.toggleRead], // 标记为未读
        [
          !!~[-1, 1].indexOf(accountAccess), false, 'icon-iconflag',
          $scope.readingMsgInfo.flags.flagged ? 'READ.MARK_AS_CANCEL_FLAGGED' : 'READ.MARK_AS_FLAGGED',
          $scope.toggleFlagged
        ], // 标记红旗 or 取消红旗
        [
          !!~[-1, 1].indexOf(accountAccess), false, 'icon-iconimportant',
          $scope.readingMsgInfo.priority == 1 ? 'MAIL.SET_NORMAL' : 'MAIL.SET_URGENT',
          $scope.setPriority.bind(null, $scope.readingMsgInfo.priority == 1)
        ], // 设为普通 or 设为紧急
        [!!~[-1, 1].indexOf(accountAccess), false, 'icon-icondelete', 'OP.DELETE', $scope.deleteReadingMsg], // 删除
      ], item => generateData(...item)), item => item.isShow)

      const optionsType2 = filter(map([
        [isAudit, readError, 'icon-Audit_pass', 'OP.AUDIT_PASS', $scope.openAuditModal.bind(null, true)], // 审核通过
        [isAudit, readError, 'icon-Audit_refusal', 'OP.AUDIT_REJECT', $scope.openAuditModal.bind(null, false)], // 审核拒绝
        [!isAudit && !isSent && !!~[-1, 1].indexOf(accountAccess), readError, 'icon-iconflag', 'OP.MARK', $scope.handleReadingMark], // 标记(x)
        [!isSent && accountAccess, readError, 'icon-iconreply', 'OP.REPLY_AND_FORWARD', $scope.replyAndForward], // 回复 or 转发(x)
        [!isAudit && !isSent && !!~[-1, 1].indexOf(accountAccess), readError, 'icon-icondelete', 'OP.DELETE', $scope.deleteReadingMsg], // 删除
        [isSent && recallStatus && accountAccess, readError, 'icon-icon_recall', 'OP.VIEW_RECALL_RESULT', $scope.openRecallConfirm], // 召回结果
        [isSent && !recallStatus && accountAccess, readError, 'icon-icon_recall', 'OP.RECALL_MAIL', $scope.openRecallConfirm], // 召回邮件
        [isSent, readError, 'icon-icon_state', 'OP.STATUS', $scope.openDeliveryStatusModal], // 投递状态
        [isSent, readError, 'icon-iconwrite', 'OP.EDIT_AGAIN', $scope.sendAgain], // 再次编辑
        [(!isSent || !isAudit) && accountAccess && !$rootScope.settings.wechatMiniProgram, readError, 'icon-iconmove', 'OP.MOVE', $scope.moveMessage], // 移动
        [(isSent || isAudit) && accountAccess, false, 'icon-icon_more', 'OP.MORE', $scope.handleMoreActions.bind(null, accountAccess)], // 更多(x)
      ], item => generateData(...item)), item => item.isShow)

      $scope.optionsType1 = [] // [[],[],[],[]]
      let row = 0
      angular.forEach(optionsType1, item => {
        $scope.optionsType1[row] = $scope.optionsType1[row] || []
        $scope.optionsType1[row].push(item)
        $scope.optionsType1[row].length > 7 && row++
      })
      $scope.optionsType2 = optionsType2
    }

    $scope.goBack = function (options) {
      // $ionicHistory.goBack(-1);
      //  删除、移动邮件返回列表，暂时做刷新处理
      $ionicHistory.nextViewOptions({
        historyRoot: true
      })
      if ($scope.isMailDealings) {
        window.history.go(-1)
      } else {
        if ($scope.params.fid == -2) {
          $rootScope.$emit('LIST.REFRESH')
        }
        $state.go('frame.folder', { fid: $scope.params.fid }, options)
      }
      window.removeEventListener('message', closeCloudStorageModal, true)
    }

    // 显示信件收件人、时间等
    $scope.toggle = function () {
      $scope.showComplete = !$scope.showComplete
      $scope.$broadcast('READ.CONTENT_LOADED')
      $ionicScrollDelegate.resize()
    }

    //  上一封邮件
    $scope.preMail = function () {
      const preMid = $scope.messageItem ? $scope.messageItem.preMid : ''
      if (preMid) {
        /** todo: 应该和完全可以和 frame.read 用同一个路由 */
        if ($scope.params.keyword) {
          $state.go('frame.readDealing', {
            mid: preMid,
            fid: $scope.params.fid,
            keyword: $scope.params.keyword
          })
          $ionicViewSwitcher.nextDirection('back')
        } else {
          $state.go('frame.read', { mid: preMid, fid: $scope.params.fid })
          $ionicViewSwitcher.nextDirection('back')
        }
      }
    }

    //  下一封邮件
    $scope.nextMail = function () {
      const nextMid = $scope.messageItem ? $scope.messageItem.nextMid : ''
      if (nextMid) {
        if ($scope.params.keyword) {
          /** todo: 应该和完全可以和 frame.read 用同一个路由 */
          $state.go('frame.readDealing', {
            mid: nextMid,
            fid: $scope.params.fid,
            keyword: $scope.params.keyword
          })
          $ionicViewSwitcher.nextDirection('forward')
        } else {
          $state.go('frame.read', { mid: nextMid, fid: $scope.params.fid })
          $ionicViewSwitcher.nextDirection('forward')
        }
      }
    }

    // 标记邮件
    $scope.handleReadingMark = function () {
      const readingMsgInfo = $scope.readingMsgInfo || {}
      const mailFlags = readingMsgInfo.flags || {}
      const mailFlagged = mailFlags.flagged
      const mailRead = true
      const isUrgentMail = readingMsgInfo.priority == 1
      $ionicActionSheet.show({
        buttons: [
          { text: "<p class='actionText'>" + $translate.instant(mailRead ? 'MAIL.MARK_AS_UNREAD' : 'MAIL.MARK_AS_READ') + '</p>' },
          { text: "<p class='actionText'>" + $translate.instant(mailFlagged ? 'READ.MARK_AS_CANCEL_FLAGGED' : 'READ.MARK_AS_FLAGGED') + '</p>' },
          { text: "<p class='actionText'>" + $translate.instant(isUrgentMail ? 'MAIL.SET_NORMAL' : 'MAIL.SET_URGENT') + '</p>' },
        ],
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index) {
          switch (index) {
            case 0:
              $scope.toggleRead()
              break
            case 1:
              $scope.toggleFlagged()
              break
            case 2:
              $scope.setPriority(isUrgentMail)
            // no default
          }
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    // 标记旗帜
    $scope.toggleFlagged = function () {
      const messageInfo = $scope.messageItem.messageInfo || {}
      const isFlagged = !messageInfo.flags.flagged
      $scope.messageItem.mark('flagged', isFlagged, null, $scope.mboxa).then(function () {
        // todo
        $scope.readingMsgInfo.flags.flagged = isFlagged
        // 如果是搜索结果进来的,更新已经存在的文件夹
        if ($scope.folder instanceof KeywordSearchMail) {
          mailFolderService.updateMailsById($scope.messageItem)
        }

        // $rootScope.$emit('LIST.REFRESH')
      })
    }

    // 标记未读
    $scope.toggleRead = function () {
      const isRead = false
      $scope.messageItem.mark('read', isRead, null, $scope.mboxa).then(function () {
        $scope.$emit('FOLDER.UNREADREFRESH')
        $scope.readingMsgInfo.flags.read = isRead
        if ($rootScope.settings.wechatMiniProgram) {
          uni.reLaunch({
            url: '/pages/main/main'
          })
        }
        $scope.goBack({ reload: false })

        if ($scope.folder instanceof KeywordSearchMail) {
          mailFolderService.updateMailsById($scope.messageItem)
        }
        // $rootScope.$emit('LIST.REFRESH')
      })
    }

    // 删除邮件
    $scope.deleteReadingMsg = function () {
      const messageDel = $scope.messageItem || {}
      const fid = messageDel.messageInfo ? messageDel.messageInfo.fid : ''
      $ionicActionSheet.show({
        titleText: $translate.instant(fid == 4 ? 'MAIL_OP_TIPS.ALERT_REAL_DELETE' : 'MAIL_OP_TIPS.ALERT_MAIL_DELETE'),
        destructiveText: "<p class='actionText'>" + $translate.instant('OP.DELETE') + '</p>',
        cancelText: $translate.instant('OP.CANCEL'),
        destructiveButtonClicked: function () {
          $scope.folder.removeMessages([messageDel], $scope.mboxa).then(function () {
            // $broadcast
            showNotify($translate.instant('MAIL_OP_TIPS.DELETE_SUCCESS'))
            if ($rootScope.settings.wechatMiniProgram) {
              uni.reLaunch({
                url: '/pages/main/main'
              })
              return true
            }

            // 非当前邮箱账号删除邮件不返回上一级路由刷新
            const currentMboxa = User.getSelectedAccountSymbol()
            if (currentMboxa !== $scope.mboxa) return
            $scope.goBack({ reload: true })
          })
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    //  回复或转发
    $scope.replyAndForward = function () {
      const readingMsgInfo = $scope.readingMsgInfo || {}
      if (readingMsgInfo.flags.webReadOnly) {
        $utils.$notify.set({ message: $translate.instant('READ.FORBIDFORWARD') })
        return
      }
      $ionicActionSheet.show({
        buttons: [
          { text: "<p class='actionText'>" + $translate.instant('OP.REPLY') + '</p>' },
          { text: "<p class='actionText'>" + $translate.instant('OP.REPLY_ALL') + '</p>' },
          { text: "<p class='actionText'>" + $translate.instant('OP.FORWARD') + '</p>' }
        ],
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index) {
          switch (index) {
            case 0:
              $state.go('frame.compose', { action: 'reply', mid: readingMsgInfo.id, mboxa: $scope.mboxa })
              break
            case 1:
              $state.go('frame.compose', { action: 'replyAll', mid: readingMsgInfo.id, mboxa: $scope.mboxa })
              break
            case 2:
              $state.go('frame.compose', { action: 'forward', mid: readingMsgInfo.id, mboxa: $scope.mboxa })
              break
            // no default
          }
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }
    // 打开选项面板
    $scope.openOptions = function () {
      if ($scope.showOptions) return

      $scope.showOptions = true
      initFooterOptions()

      $timeout(_ => {
        const footerOptionsRef = angular.element(document.getElementById('footerOptionsRef'))
        const handleOptionsPanelClose = function(event) {
          if (footerOptionsRef[0].contains(event.target) && event.target.tagName.toLowerCase() !== 'button') return

          footerOptionsRef.addClass('leave')
          $timeout(_ => ($scope.showOptions = false), 250)
          document.removeEventListener('click', handleOptionsPanelClose, false)
        }
        footerOptionsRef.addClass('enter')
        document.addEventListener('click', handleOptionsPanelClose, false)
      })
    }
    $scope.replyInputPlaceholder = $translate.instant('READ.QUICK_REPLY')
    // 处理快速回复点击
    $scope.handleInputFocus = function () {
      $scope.showQuickReplyPanel = true
      $scope.inputActive = true
      document.addEventListener('click', handleWQuickReplyPanelOtherClick, false)
      // 防止遮挡
      $timeout(function() {
        document.documentElement.scrollTop = document.documentElement.scrollHeight
        document.body.scrollTop = document.body.scrollHeight
      }, 100)
      $scope.replyInputPlaceholder = $translate.instant('READ.ACTIVE_REPLY_PLACEHOLDER')
      function handleWQuickReplyPanelOtherClick(event) {
        if (!event.target.classList.contains('quick-reply')) {
          $scope.showQuickReplyPanel = false
          $scope.inputActive = false
          document.removeEventListener('click', handleWQuickReplyPanelOtherClick)
          $scope.$digest()
        }
      }
    }
    // 处理快速回复失焦
    $scope.handleInputBlur = function () {
    }
    // 处理快速回复改变
    $scope.handleInputChange = function () {
      LocalStorage.setItem('quickReply', $scope.replyModel)
    }
    // 快捷回复
    $scope.replyModel = {
      content: '',
      mid: $scope.params.mid
    } // 回复内容
    $scope.toAll = false // 是否回复全部
    $scope.quickReply = function () {
      const content = `${$scope.replyModel.content}<br><br>` + globalMailService.getQuoteHTMLStart('reply', $scope.readingMsgInfo)
      readService.replyMessage({
        id: $scope.params.mid,
        toAll: $scope.toAll,
        subject: 'Re: ' + $scope.readingMsgInfo.subject,
        quoteHTMLStart: content,
        mboxa: $scope.mboxa
      }).then(function (data) {
        $scope.replyModel = {
          content: '',
          mid: $scope.params.mid
        }
        $utils.$notify.set({message: $translate.instant('READ.REPLY_SUCCESS')})
      }, function(res) {
        const code = res.code
        const failMsg = $translate.instant('READ.REPLY_FAIL', { code })
        const codeMsg = $translate.instant(`READ.${code}`)
        $utils.$notify.set({message: codeMsg === `READ.${code}` ? failMsg : codeMsg})
      })
    }
    // 计算回复全部的人数
    function replyAllNumber(contacts) {
      const currentUserId = User.getCurrentUser().config.email
      const replyContactList = []
      if (contacts) {
        for (let i = 0; i < contacts.length; i++) {
          if ($utils.$email.parse(contacts[i]).addr !== currentUserId) {
            replyContactList.push(contacts[i])
          }
        }
      }
      return replyContactList.length
    }
    // 回复全部点击
    $scope.handleToAllClick = function () {
      // // 自动聚焦
      // const quickReplyInput = document.querySelector('[nav-view=active] #quick-reply-input')
      // if (quickReplyInput) {
      //   quickReplyInput.blur()
      //   $timeout(_ => { quickReplyInput.focus() })
      // }
      $scope.toAll = !$scope.toAll
      if ($scope.toAll && !$scope.replyAllNumber) {
        const {from = [], to = [], cc = []} = $scope.readingMsgInfo
        const contacts = unionBy([].concat(from, to, cc))
        $scope.replyAllNumber = replyAllNumber(contacts)
      }
    }
    // 完整模式回复
    $scope.expandReply = function () {
      $timeout(function () {
        if ($scope.toAll) {
          $scope.replyAll()
        } else {
          $scope.reply()
        }
      }, 300)
    }
    // 回复
    $scope.reply = function () {
      if ($scope.isWebReadOnly) {
        $utils.$notify.set({ message: $translate.instant('READ.FORBIDFORWARD') })
        return
      }
      $scope.replyModel.content = ''
      $state.go('frame.compose', { action: 'reply', mid: $scope.readingMsgInfo.id, mboxa: $scope.mboxa })
    }
    $scope.replyAll = function () {
      if ($scope.isWebReadOnly) {
        $utils.$notify.set({ message: $translate.instant('READ.FORBIDFORWARD') })
        return
      }
      $scope.replyModel.content = ''
      $state.go('frame.compose', { action: 'replyAll', mid: $scope.readingMsgInfo.id, mboxa: $scope.mboxa })
    }
    // 转发
    $scope.forward = function () {
      if ($scope.isWebReadOnly) {
        $utils.$notify.set({ message: $translate.instant('READ.FORBIDFORWARD') })
        return
      }
      $state.go('frame.compose', { action: 'forward', mid: $scope.readingMsgInfo.id, mboxa: $scope.mboxa })
    }
    // 移动邮件
    $scope.moveMessage = function () {
      $scope.folderHandlerDelegate = {
        selectFolder: function (iFolderId) {
          $scope.folderModal.hide()
          if ($scope.messageItem) {
            mailFolderService.getFolder(iFolderId, $scope.mboxa).then(function (oFolder) {
              $scope.folder.moveMsgsToFolder([$scope.messageItem], oFolder, $scope.mboxa).then(function (data) {
                showNotify($translate.instant('MAIL_OP_TIPS.MOVE_SUCCESS').replace('{0}', oFolder.name))
                // 非当前邮箱账号移动邮件不返回上一级路由刷新
                const currentMboxa = User.getSelectedAccountSymbol()
                if (currentMboxa !== $scope.mboxa) return
                $scope.goBack({ reload: true })
              })
            }, function (reason) {
              $utils.$notify.set({ message: $translate.instant('MAIL_OP_TIPS.MOVE_FAILED') })
              throw reason // todo
            })
          }
        }
      }
      openSelectFolderModal()
    }

    $scope.closeSelectFolderModal = function () {
      $scope.folderModal.hide()
    }

    // 已发送读信页更多操作
    $scope.handleMoreActions = function (access) {
      const readingMsgInfo = $scope.readingMsgInfo || {}
      const mailFlags = readingMsgInfo.flags || {}
      const mailFlagged = mailFlags.flagged
      const mailRead = true
      const isUrgentMail = readingMsgInfo.priority == 1
      const btns = [
        { id: 1, text: "<p class='actionText'>" + $translate.instant(mailRead ? 'MAIL.MARK_AS_UNREAD' : 'MAIL.MARK_AS_READ') + '</p>' },
        { id: 2, text: "<p class='actionText'>" + $translate.instant(mailFlagged ? 'READ.MARK_AS_CANCEL_FLAGGED' : 'READ.MARK_AS_FLAGGED') + '</p>' },
        { id: 3, text: "<p class='actionText'>" + $translate.instant(isUrgentMail ? 'MAIL.SET_NORMAL' : 'MAIL.SET_URGENT') + '</p>' },
        { id: 4, text: "<p class='actionText'>" + $translate.instant('OP.REPLY') + '/' + $translate.instant('OP.FORWARD') + '</p>' },
        { id: 5, text: "<p class='actionText'>" + $translate.instant('OP.MOVE') + '</p>' },
        { id: 6, text: "<p class='actionText delete-warning'>" + $translate.instant('OP.DELETE') + '</p>' },
      ]
      // 代表的共享账号只有回复/转发权限
      const btn = access === 2 ? [btns[3]] : []
      if ($scope.isAudit) {
        btns.splice(3, 1)
      }
      $ionicActionSheet.show({
        buttons: btn.length ? btn : btns,
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index, buttonInfo) {
          switch (buttonInfo.id) {
            // 标记未读
            case 1:
              $scope.toggleRead()
              break
            // 标记旗帜
            case 2:
              $scope.toggleFlagged()
              break
            // 设为紧急
            case 3:
              $scope.setPriority(isUrgentMail)
              break
            // 回复转发
            case 4:
              $scope.replyAndForward()
              break
            // 移动
            case 5:
              $scope.moveMessage()
              break
            // 删除
            case 6:
              $scope.deleteReadingMsg()
              break
          }
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    // 打开审核
    $scope.openAuditModal = function (status) {
      $scope.auditModal = $phoneModal.fromTemplate(require('views/mail/audit.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.auditModal.el.style.zIndex = 11
      $scope.auditModal.show()
      $scope.openAuditStatus = status
    }

    $scope.handleAudit = function (data) {
      const params = {
        auditAction: 1,
        hostId: $scope.readingMsgInfo.orgauditinfo.hostid,
        tid: $scope.readingMsgInfo.orgauditinfo.tid,
        auditer: $scope.readingMsgInfo.orgauditinfo.auditer,
        auditee: $scope.readingMsgInfo.orgauditinfo.auditee,
        checksum: Number($scope.readingMsgInfo.orgauditinfo.checksum),
        auditeeType: Number($scope.readingMsgInfo.orgauditinfo.auditeetype)
      }
      if (data) {
        params.auditAction = 2
        params.desc = data
      }
      readService.handleAudit(params).then(res => {
        if (res.code === 'S_OK' && data) $utils.$notify.set({ message: $translate.instant('TIPS.MAIL_AUDIT_REJECT') })
        else if (res.code === 'S_OK' && !data) $utils.$notify.set({ message: $translate.instant('TIPS.MAIL_AUDIT_SUCCESS') })
        else $utils.$notify.set({ message: $translate.instant('TIPS.NETWORK_ERROR') })
        $scope.closeAuditModal()
      }, err => {
        if (err.code === 'FA_ALREADY_AUDIT') $utils.$notify.set({ message: $translate.instant('TIPS.MAIL_AUDIT_ALREADY') })
      })
    }

    $scope.closeAuditModal = function () {
      $scope.auditModal.remove()
    }

    // 打开召回邮件确认弹框
    $scope.openRecallConfirm = function () {
      if ($scope.recallStatus) {
        $scope.openRecallResultModal()
        return
      }
      const confirmPopup = $ionicPopup.confirm({
        template: $translate.instant('OP.CONFIRM_TO_RECALLMAIL'),
        cancelText: $translate.instant('OP.CANCEL'),
        cancelType: 'button-positive',
        okText: $translate.instant('OP.CONFIRM'),
        okType: 'button-default'
      })
      confirmPopup.then(function (res) {
        if (res) {
          const options = {
            mid: $scope.params.mid,
            mboxa: $scope.mboxa
          }
          readService.recallMail(options).then(function (data) {
            if (data.code === 'S_OK') {
              $scope.recallStatus = true
              $scope.openRecallOperationResultModal()
            }
          }, function (error) {
            console.log(error)
            $utils.$notify.set({ message: $translate.instant('OP.RECALL_FAIL') })
          })
        }
      })
    }
    // 打开召回操作结果弹窗
    $scope.openRecallOperationResultModal = function (didRecall) {
      const popupTemplate = didRecall ? $translate.instant('OP.DIDRECALL') : $translate.instant('OP.RECALL_OPERATION_DONE')
      $ionicPopup.confirm({
        template: popupTemplate,
        buttons: [{
          text: $translate.instant('OP.VIEW_RECALL_RESULT'),
          type: 'button-default',
          onTap: function (e) {
            $scope.openRecallResultModal()
          }
        }]
      })
    }
    // 打开邮件召回状态模态框
    $scope.openRecallResultModal = function () {
      $scope.recallResultModal = $phoneModal.fromTemplate(require('views/mail/recallResult.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.recallResultModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.recallResultModal)
      $scope.recallResultModal.show()
      const options = {
        mid: $scope.params.mid,
        mboxa: $scope.mboxa
      }
      $loading.show()
      readService.getDeliveryStatus(options).then(function (res) {
        if (res.code === 'S_OK') {
          const list = res.var
          const temp = []
          let rcCode
          list.forEach(function (item) {
            const arrayItem = {}
            rcCode = item.rclResult
            Object.keys(recallResultType).forEach(function (prop) {
              if (recallResultType[prop] === rcCode) {
                arrayItem.result = $translate.instant('RECALL_STATUS.' + prop)
              }
            })
            arrayItem.name = item.to_name || item.to
            arrayItem.email = item.to
            if (rcCode === 2 || rcCode === 3) {
              arrayItem.recallSuccess = true
            } else {
              arrayItem.recallSuccess = false
            }
            temp.push(arrayItem)
          })
          $scope.recallResultList = temp
        } else {
          $utils.$notify.set({ message: $translate.instant('READ.BIG_ATTACHMENT_SAVE_TIPS') })
          $scope.openRecallResultModal.remove()
        }
        $loading.hide()
      })
    }
    // 关闭邮件召回状态模态框
    $scope.closeRecallResultModal = function () {
      $scope.recallResultModal.remove()
    }

    // 打开邮件投递状态模态框
    $scope.openDeliveryStatusModal = function () {
      $scope.deliveryStatusModal = $phoneModal.fromTemplate(require('views/mail/deliveryStatus.html'), {
        scope: $scope,
        cache: false,
        animation: 'slide-in-up'
      })
      $scope.deliveryStatusModal.el.style.zIndex = 11
      $utils.$modalFunc.prepareModalBack($scope.deliveryStatusModal)
      $scope.deliveryStatusModal.show()
      const options = {
        mid: $scope.params.mid,
        mboxa: $scope.mboxa
      }
      $loading.show()
      readService.getDeliveryStatus(options).then(function (res) {
        // http://wiki.mailtech.cn/pages/viewpage.action?pageId=11502844 投递状态文档
        if (res.code === 'S_OK') {
          if (!res.var[0]) {
            $scope.isDeliveryHistoryEmpty = true
          }
          const list = res
          let readCount = 0
          let failCount = 0
          const failExtend = [1, 4, 6, 7, 8, 9, 14, 15, 101, 104, 404, 105, 205, 110, 201, 204, 102, 202, 103, 203, 602, 403, 809]
          list.var.forEach(ele => {
            if (ele.result === 509 || ele.result === 109 || ele.result === 709 || ele.rclResult === 5) readCount++
            if (~failExtend.indexOf(ele.result) || ~failExtend.indexOf(ele.rclResult)) {
              failCount++
              ele.notRight = true
            }
            const code = deliveryStatusDescription(ele)
            ele.status = code
          })
          list.readCount = readCount
          list.failCount = failCount
          $scope.deliveryStatusList = list
          $scope.deliveryStatusCount = {
            send: list.total,
            read: readCount,
          }
        } else {
          $utils.$notify.set({ message: $translate.instant('READ.BIG_ATTACHMENT_SAVE_TIPS') })
          $scope.deliveryStatusModal.remove()
        }
        $loading.hide()
      })
    }
    // 关闭邮件投递状态模态框
    $scope.closeDeliveryStatusModal = function () {
      $scope.deliveryStatusModal.remove()
    }
    // 再次发送
    $scope.sendAgain = function () {
      const readingMsgInfo = $scope.readingMsgInfo || {}
      $state.go('frame.compose', { action: 'sendAgain', mid: readingMsgInfo.id, mboxa: $scope.mboxa })
    }
    // 设为紧急或设为普通, 1是紧急, 3是普通, isUrgentMail表示当前的邮件是否已经设置了设为紧急
    $scope.setPriority = function (isUrgentMail) {
      mailService.updateMessageInfos([$scope.readingMsgInfo.id], { priority: isUrgentMail ? 3 : 1 }, $scope.mboxa).then(function () {
        $scope.readingMsgInfo.priority = isUrgentMail ? 3 : 1
        $utils.$notify.set({ message: $translate.instant('OP.SETUP_SUCCESS') })
        $scope.messageItem.messageInfo.priority = isUrgentMail ? 3 : 1
      }, function () {
        $utils.$notify.set({ message: $translate.instant('OP.SETUP_FAIL') })
      })
    }

    // 获取输入的密码
    $scope.getEncryptedPassword = function ($event) {
      const ngTarget = angular.element($event.target)
      $scope.eableDecryptBtn = $scope.encryptedPassword = ngTarget.val()
      $scope.passwordError = false
    }
    //  普通加密邮件解密
    $scope.handleDecryptMessage = function ($event) {
      const data = {
        id: $scope.params.mid,
        password: $scope.encryptedPassword,
        mboxa: $scope.mboxa
      }
      $scope.disableDecryptBtnTxt = $translate.instant('READ.PASSWORD_VERIFICATION')
      $scope.eableDecryptBtn = false
      readService.decryptMessage({
        id: $scope.params.mid,
        mboxa: $scope.mboxa
      }, data).then(function (data) {
        $scope.passwordError = false
        $scope.readingMsgInfo.mailCipherEncrypted = false
        $scope.readingMsgInfo.mailContent = data.mailContent
        $scope.readingMsgInfo.attachments = data.attachments
      }, function (data) {
        $scope.passwordError = true
        showNotify(data)
      }).finally(function () {
        $scope.disableDecryptBtnTxt = $translate.instant('OP.YES')
      })
    }
    // 处理附件点击操作
    $scope.handleAttachmentItemClick = function (attachment) {
      $scope.curAttachment = attachment
      // TODO 小程序的环境应该采用标准api判断，json方式为暂时方式
      // 微信小程序环境中
      // if ($rootScope.settings.wechatMiniProgram) {
      //   uni.postMessage({
      //     data: {
      //       attach: $scope.curAttachment
      //     }
      //   })
      //   uni.redirectTo({
      //     url: '/pages/file/file'
      //   })
      //   return
      // }

      if ($scope.curAttachment.isPreview) {
        $scope.previewFile()
      } else {
        $scope.getAttachmentDetail(attachment)
      }
    }
    // 附件详情
    $scope.getAttachmentDetail = function (attachment) {
      $scope.curAttachment = attachment

      if ($scope.attachmentDetailMal) {
        $scope.attachmentDetailMal.show()
      } else {
        attachmentDetailMal()
      }
    }
    // 附件详情模态框
    function attachmentDetailMal() {
      $scope.attachmentDetailMal = $phoneModal.fromTemplate(require('views/mail/attachmentDetail.html'), {
        scope: $scope,
        animation: 'scale-in'
      })
      $utils.$modalFunc.prepareModalBack($scope.attachmentDetailMal, 'hide')
      $scope.attachmentDetailMal.show()
      $ionicPopover.fromTemplateUrl('attachmentD-popover.html', {
        scope: $scope
      }).then(function (popover) {
        $scope.attachpopover = popover
      })
    }

    $scope.closeAttachmentDetail = function () {
      $scope.attachmentDetailMal.hide()
    }

    //  附件操作
    $scope.attachmentMoreOp = function ($event) {
      $scope.attachpopover.show($event)
    }

    // 附件下载
    $scope.downloadAttachment = function () {
      if ($rootScope.settings.wechatMiniProgram) {
        $utils.$notify.set({ message: $translate.instant('MINI_PROGRAM.DOWNLOAD_NOT_SUPPORTED') })
        return
      }

      const attachment = $scope.curAttachment
      // 屏蔽外网下载附件
      if ($rootScope.settings.disableExtranetDownload) {
        const account = LocalStorage.getItem('account') || {}
        const currentUser = account[account.currentUserId] || {}
        const isIntranetIp = get(currentUser, '$ajc.intranetAddr', true)
        if (!isIntranetIp) {
          $utils.$notify.set({ message: $translate.instant('READ.OUTER_NET_DOWNLOAD_TIPS') })
          return
        }
      }

      // 检查附件风险
      attachment.from = $scope.readingMsgInfo.from[0]
      mailService.checkAttachmentRisk([attachment], $translate.instant('READ.DOWNLOAD')).then(res => {
        if (!res) return

        const urlPrefix = User.getCurrentUser().wmsvrClient.getWmsvrURLPrefix()
        const byToken = $rootScope.settings.featureControl.read.enableAttachmentDownloadByToken || $utils.$misc.MD.isWeChat
        if (byToken && $rootScope.settings.wechatMiniProgram) {
          const data = attachment
          uni.navigateTo({
            url: '/pages/file/file?fileDetail=' + encodeURIComponent(JSON.stringify(data))
          })
          return
        }

        const getDownloadURLDefer = byToken ? $http({
          method: 'GET',
          url: urlPrefix + '/cmcu_addon/generateToken.jsp?sid=' + User.getCurrentUser().sid
        }).then(res => {
          return globalUtils.setQueryParams(`${urlPrefix}/cmcu_addon/readAttachment.jsp`, {
            token: res.data.result,
            mid: attachment.path,
            partId: attachment.id,
            mboxa: $scope.mboxa
          })
        }) : $q.resolve(
          globalUtils.setQueryParams(attachment.downloadURL, {
            estimateSize: attachment.estimateSize,
            ctype: attachment.contentType,
            time: (new Date($scope.readingMsgInfo.sentDate.replace(/-/g, '/'))).getTime(),
            mboxa: $scope.mboxa
          })
        )
        getDownloadURLDefer.then(downloadURL => {
          const copyAttachment = angular.copy(attachment)
          copyAttachment.downloadURL = downloadURL
          globalHook.exec('handleAttachmentDownload', copyAttachment).catch(_ => {
            if ($rootScope.settings.wxwork.enable && $utils.$misc.MD.isWorkWeChat) { // 企业微信下载
              // TODO: 考虑后续是否把readAttachment.jsp都替换成这里的下载方式
              // 特殊处理企业微信加密附件的下载
              if (attachment.mailCipherPassword) {
                const token = globalUtils.getQueryParams(downloadURL, 'token')
                downloadURL = globalUtils.setQueryParams(attachment.downloadURL, {
                  estimateSize: attachment.estimateSize,
                  ctype: attachment.contentType,
                  time: (new Date($scope.readingMsgInfo.sentDate.replace(/-/g, '/'))).getTime(),
                  mboxa: $scope.mboxa,
                  cToken: token.split(':')[1]
                })
              }
              wechatService.previewFile(downloadURL, attachment.attsize, attachment.filename)
            } else { // 其他
              console.log('--- downloadAttachment ---', downloadURL)
              $window.location.href = downloadURL
            }
          })
        })
      })
      $scope.attachpopover && $scope.attachpopover.hide()
    }
    // 附件更多
    $scope.handleMoreOptions = function (attachment) {
      $scope.curAttachment = attachment
      const $ajc = User.getConfig()['$ajc']
      const hasPerNetfolder = $ajc['nf'] && $ajc['nf']['enabled']
      const buttons = []
      if (!$scope.curAttachment.mailCipherPassword) {
        buttons.push({ text: "<p class='actionText'>" + $translate.instant('READ.SEND_WITH_ATTACH') + '</p>', id: 1 })
      }
      if ($rootScope.settings.featureControl.fileCenter.enableMoveToPersonalNetworkDisk && hasPerNetfolder && $rootScope.settings.featureControl.fileCenter.enablePersonalNetworkDisk) {
        buttons.push({ text: "<p class='actionText'>" + $translate.instant($scope.justSaveToNF_id === $scope.curAttachment.id ? 'READ.CHECK_PNF' : 'READ.SAVE_TO_PNF') + '</p>', id: 2 })
      }
      if ($rootScope.settings.featureControl.read.enableAttachmentDownload) {
        buttons.push({ text: "<p class='actionText'>" + $translate.instant('READ.DOWNLOAD') + '</p>', id: 3 })
      }
      if (User.getConfig().xnfSwitch) {
        buttons.push({ text: "<p class='actionText'>" + $translate.instant('NETFOLDER.UPLOAD_TO_XNF') + '</p>', id: 4 })
      }
      $ionicActionSheet.show({
        buttons: buttons,
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index, buttons) {
          const id = buttons.id
          switch (id) {
            case 1:
              $scope.sendMailWithAttach()
              break
            case 2:
              if ($scope.justSaveToNF_id === $scope.curAttachment.id) {
                LocalStorage.setItem('perNFListBack', { page: $state.current.name, params: $state.params })
                $state.go('frame.nfList', { type: 'per', path: '/0' })
              } else {
                $scope.openNTFModal()
              }
              break
            case 3:
              $scope.downloadAttachment(attachment)
              break
            case 4:
              $scope.openCloudStorageModal(attachment)
          }
          return true
        },
        cancel: function () {
        }
      })
    }

    // 打开第三方网盘
    $scope.openCloudStorageModal = function (attachment) {
      const { id, path } = attachment
      $scope.selectCloudStorageModal = $phoneModal.fromTemplate(require('views/netFolder/cloudStorageModal.html'), {
        scope: $scope,
        animation: 'scale-in'
      })
      $scope.selectCloudStorageModal.el.style.zIndex = 11
      $scope.selectCloudStorageModal.show()
      const ln = document.querySelector('#cloudStorageModal')
      ln.src = $$misc.subModule.cloudStorageSrc
      ln.onload = function () {
        const params = {
          type: 'save',
          parts: path,
          id: id
        }
        const targetOrigin = $$misc.subModule.getPostMsgOrigin($utils.$html.getBaseURL())
        ln.contentWindow.postMessage(params, targetOrigin)
      }
      $scope.attachpopover && $scope.attachpopover.hide()
    }

    $scope.closeCloudStorageModal = function () {
      $scope.selectCloudStorageModal.remove()
    }

    function closeCloudStorageModal(e) {
      const type = e.data.type
      if (type === 'save-success') {
        $utils.$notify.set({ message: $translate.instant('OP.SAVE_SUC') })
      }
      if (type === 'save-success' || type === 'back') $scope.selectCloudStorageModal.remove()
    }

    window.addEventListener('message', closeCloudStorageModal, true)

    // 单个附件点击下载
    $scope.handleDownloadClick = function (attachment) {
      $scope.curAttachment = attachment
      $scope.downloadAttachment(attachment)
    }

    //  附件预览
    $scope.previewFile = function () {
      globalMailService.openAttachPreviewModal($scope, $scope.curAttachment.previewURL)
    }
    // 作为附件转发
    $scope.sendMailWithAttach = function () {
      const attachment = $scope.curAttachment

      // 检查附件风险
      attachment.from = $scope.readingMsgInfo.from[0]
      mailService.checkAttachmentRisk([attachment], $translate.instant('READ.SEND_WITH_ATTACH')).then(res => {
        if (!res) return

        attachment.size = attachment.estimateSize
        attachment.name = attachment.filename
        netFolderService.setComposeFile(attachment)
        $state.go('frame.compose', { action: 'composeWithInternalAttachment' })
      })
    }

    //  打开个人网盘视图
    $scope.openNTFModal = function () {
      const attachment = $scope.curAttachment

      // 检查附件风险
      attachment.from = $scope.readingMsgInfo.from[0]
      mailService.checkAttachmentRisk([attachment], $translate.instant('READ.SAVE_TO_PNF')).then(res => {
        if (!res) return

        netFolderService.getFolderList(0, {}).then(function (data) {
          if (data['code'] == 'S_OK') {
            $scope.ntFolderList = data['var']
            ntFolderModal()
          }
        })
      })

      $scope.attachpopover && $scope.attachpopover.hide()
    }

    function ntFolderModal() {
      $phoneModal.fromTemplateUrl('ntfList.html', {
        scope: $scope,
        animation: 'slide-in-up'
      }).then(function (modal) {
        modal.el.style.zIndex = 15
        $scope.ntFolderList.modal = modal
        modal.show()
      })
    }

    $scope.closeNTFModal = function (ntFolderList) {
      ntFolderList.modal.hide()
    }

    //  附件保存到个人网盘
    $scope.saveMessageToNF = function (attachment) {
      const mid = $scope.params.mid
      const part = $scope.curAttachment.id
      const parts = mid + '/' + part
      $scope.ntFolderList.modal.remove()
      readService.saveMessageToNF({ fid: $scope.ntFolderList.id, parts: [parts] }).then(function (data) {
        if (data['code'] == 'S_OK') {
          $scope.justSaveToNF_id = $scope.curAttachment.id
          $scope.ntFolderList.name = $scope.ntFolderList.name || $translate.instant('NETFOLDER.PERSONAL_NETFOLDER')
          showNotify($translate.instant('READ.SAVE_TO_PNF_SUCCESS').replace('{0}', $scope.ntFolderList.name))
        }
      }, function (error) {
        if (error['code'] == 'FA_OVERFLOW') {
          $utils.$pop.alertPopup($translate.instant('READ.SAVE_TO_PNF_FAILED'), $translate.instant('READ.FA_OVERFLOW'))
        }
      })
    }

    $scope.openChildrenNTFModal = function (ntFolderList, folder) {
      $scope.ntFolderList = folder
      $scope.ntFolderList.parent = ntFolderList
      $scope.closeNTFModal(ntFolderList)
      ntFolderModal()
    }

    $scope.backToParentModal = function (ntFolderList) {
      ntFolderList = ntFolderList || $scope.ntFolderList
      if (ntFolderList.parent) {
        $scope.ntFolderList = ntFolderList.parent
        ntFolderList.parent.modal.show()
      }
      $scope.closeNTFModal(ntFolderList)
    }

    // 回复会议邀请邮件 (接受、拒绝、待定)
    $scope.handleReplyMeetingRequest = function (status) {
      const params = {
        id: $scope.params.mid,
        userAttendeeStatus: status
      }
      const replyStatus = {
        2: $translate.instant('OP.TENTATIVE'),
        3: $translate.instant('OP.ACCEPT'),
        4: $translate.instant('OP.DECLINE')
      }
      const calendarStatus = {
        2: $translate.instant('MEETING_ADDED'),
        3: $translate.instant('MEETING_ADDED'),
        4: $translate.instant('MEETING_DELETED')
      }
      readService.replyMeetingRequest(params).then(function () {
        $scope.readingMsgInfo.calendar.meetingRequestStatus = status

        $scope.readingMsgInfo.calendar.participationDisplay = ($translate.instant('MEETING_PARTICIPATION_DISPLAY').replace('{0}', replyStatus[status]) || '') +
          ', ' + (calendarStatus[status] || '')
      }, function (error) {
        console.log(error)
      })
    }

    // 修改会议邀请
    $scope.handleModifyMeetingRequest = function () {
      const curStatus = $scope.readingMsgInfo.calendar.meetingRequestStatus
      const modifyButtons = [
        { status: 3, text: "<p class='actionText'>" + $translate.instant('OP.ACCEPT') + '</p>' },
        { status: 2, text: "<p class='actionText'>" + $translate.instant('OP.TENTATIVE') + '</p>' },
        { status: 4, text: "<p class='actionText'>" + $translate.instant('OP.DECLINE') + '</p>' }
      ]

      for (let i = 0; i < modifyButtons.length; i++) {
        if (modifyButtons[i].status == curStatus) {
          modifyButtons.splice(i, 1)
        }
      }

      $ionicActionSheet.show({
        buttons: modifyButtons,
        cancelText: $translate.instant('OP.CANCEL'),
        buttonClicked: function (index, item) {
          $scope.handleReplyMeetingRequest(item.status)
          return true
        },
        cancel: function () {
          // to do when cancel
        }
      })
    }

    // 添加到日程
    $scope.handleAddToCal = function () {
      readService.addToMyCal({ id: $scope.params.mid }).then(function (result) {
        if (result && result.code == 'FA_INVALID_REQUEST') {
          $utils.$notify.set({ message: $translate.instant('MEETING_PARTICIPATION_ILLEGAL') })
        } else if (result && result.code == 'FA_INVALID_ATTENDEE') {
          $utils.$notify.set({ message: $translate.instant('MEETING_PARTICIPATION_CANCEL') })
        } else if (result && result['var'] && result['var']['eventId']) {
          $scope.readingMsgInfo.calendar.calUid = result['var']['eventId']
          $utils.$notify.set({ message: $translate.instant('MEETING_ADDED') })
        }
        console.log(result)
      })
    }

    // 从日程中移除
    $scope.handleDelFromMyCal = function () {
      readService.delFromMyCal({ id: $scope.params.mid }).then(function (result) {
        if (result && result.code == 'FA_INVALID_REQUEST') {
          $utils.$notify.set({ message: $translate.instant('MEETING_PARTICIPATION_ILLEGAL') })
        } else if (result && result.code == 'FA_INVALID_ATTENDEE') {
          $utils.$notify.set({ message: $translate.instant('MEETING_PARTICIPATION_CANCEL') })
        } else if (result && result['var'] && result['var']['declined']) {
          $utils.$notify.set({ message: $translate.instant('MEETING_DELETED') })
          $scope.readingMsgInfo.calendar.calUid = false
        }
      })
    }

    // 回信申请加入会议
    $scope.handleApplyParticipation = function () {
      const meetingRequest = $scope.readingMsgInfo.calendar ? $scope.readingMsgInfo.calendar.meetingRequest : {}
      const organizer = meetingRequest.organizer || '' // 会议组织者
      $state.go('frame.compose', { action: 'forward', mid: $scope.params.mid, email: organizer })
    }
    $scope.attachScrollIntoView = function () {
      $ionicScrollDelegate.$getByHandle('readscroll').scrollBottom()
    }
    //  文件夹列表
    function openSelectFolderModal() {
      mailFolderService.listFolders($scope.mboxa).then(function (folders) {
        $scope.hideVirtualFolder = true
        const params = [$scope.messageItem]
        const fid = params[0].messageInfo.fid
        const topFolderWrappers = cloneDeep(folders.topFolders)
        const otherFolderWrappers = cloneDeep(folders.otherFolders)
        if (every(params, item => item.messageInfo.fid === fid)) {
          const disableFolder = function(folders) {
            if (!folders || !folders.length) return
            forEach(folders, folder => {
              if (folder.data.id === fid) {
                folder.data.disabled = true
              } else {
                disableFolder(folder.children)
              }
            })
          }
          disableFolder(topFolderWrappers)
          disableFolder(otherFolderWrappers)
        }
        $scope.topFolderWrappers = topFolderWrappers
        $scope.otherFolderWrappers = otherFolderWrappers
        if (!$scope.folderModal) {
          $scope.folderModal = $phoneModal.fromTemplate(require('views/mail/folders-frame.html'), {
            scope: $scope,
            animation: 'slide-in-up'
          })
          $scope.folderModal.el.style.zIndex = 15
        }
        $utils.$modalFunc.prepareModalBack($scope.folderModal, 'hide')
        $scope.folderModal.show()
      })
    }

    function showNotify(message) {
      $utils.$notify.set({ message: message })
    }
    function deliveryStatusDescription(res) {
      const strRclResult = res.rclResult
      const strCode = res.result
      if (strRclResult !== '' && strRclResult !== 'undefined' && strRclResult !== 0) {
        if (strRclResult === 1) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE1')
        else if (strRclResult === 2) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE2')
        else if (strRclResult === 3) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE3')
        else if (strRclResult === 4) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE4')
        else if (strRclResult === 5) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE5')
        else if (strRclResult === 6) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE6')
        else if (strRclResult === 7) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE7')
        else if (strRclResult === 8) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE8')
        else if (strRclResult === 9) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE9')
        else if (strRclResult === 14) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE14')
        else if (strRclResult === 15) return $translate.instant('DELIVERY_STATUS.STRID_RECALLMAIL_RESULT_CODE15')
        else return strRclResult
      } else {
        if (strCode === 100) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE100')
        else if (strCode === 101) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE101')
        else if (strCode === 104 || strCode === 404) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE104404')
        else if (strCode === 105 || strCode === 205) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE105205')
        else if (strCode === 106) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE106')
        else if (strCode === 107) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE107')
        else if (strCode === 108) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE108')
        else if (strCode === 110) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE110')
        else if (strCode === 200) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE200')
        else if (strCode === 201) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE201')
        else if (strCode === 204) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE204')
        else if (strCode === 600) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE600')
        else if (strCode === 601) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE601')
        else if (strCode === 602 || strCode === 403) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE602')
        else if (strCode === 603) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE603')
        else if (strCode === 700 || strCode === 800) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE700800')
        else if (strCode === 709 || strCode === 809) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE709809')
        else if (strCode === 102 || strCode === 202) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE102202')
        else if (strCode === 103 || strCode === 203) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE103203')
        else if (strCode === 109 || strCode === 509) return $translate.instant('DELIVERY_STATUS.STRID_VIEWRECALLMAIL_DH_CODE109509')
        else {
          return strCode //eslint-disable-line
        }
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/read/readCtrl.js